import React from 'react';
import { DocumentsTableProps, iconType } from './DocumentsTable';
import { Box, Button, Text } from 'grommet';
import StyledDataTable from '../styledDataTable/StyledDataTable';
import usePagination from '../../util/usePagination';
import { formatDate } from '../../util/formatters';
import { IconContainer } from './DocumentsTableStyles';
import { Download } from '../../icons';

export default ({
  documents,
  accountNumber,
  downloadDocument
}: DocumentsTableProps) => {
  const displayableDocs = documents?.map((document, index) => ({
    icon: (
      <IconContainer>
        {document?.mimeType ? iconType(document?.mimeType) : ''}
      </IconContainer>
    ),
    file_name: (
      <Box direction="row" gap="20px" align="center">
        <Text wordBreak="break-word">
          {document?.name?.replace(/^\d{10}\s{1}/g, '')}
        </Text>
      </Box>
    ),
    classification: (
      <Text wordBreak="break-all">
        {document?.policyNumber ? document?.policyNumber : document?.jobNumber}
      </Text>
    ),
    date_uploaded: document?.dateModified,
    date_uploaded_formatted: formatDate(document?.dateModified),
    download_link: (
      <Button
        onClick={() => {
          downloadDocument({
            variables: {
              getDocById: true,
              documentID: document?.docUID
            }
          });
        }}
        icon={<Download />}
      />
    )
  }));
  const [paginatedDocs, pageSelector] = usePagination({
    accountNumber,
    items: displayableDocs,
    itemsPerPage: 25
  });
  const table = (
    <StyledDataTable
      sortable
      columns={[
        {
          sortable: false,
          property: 'icon',
          header: '',
          align: 'start'
        },
        {
          sortable: false,
          property: 'file_name',
          header: (
            <Text weight="bold" size="14pt">
              File Name
            </Text>
          ),
          align: 'start'
        },
        {
          sortable: false,
          property: 'classification',
          header: (
            <Text weight="bold" size="14pt">
              Policy number
            </Text>
          ),
          align: 'start'
        },
        {
          sortable: true,
          property: 'date_uploaded',
          header: (
            <Text weight="bold" size="14pt">
              Date Uploaded
            </Text>
          ),
          align: 'start',
          render: (datum: any) => <Text>{datum.date_uploaded_formatted}</Text>
        },
        {
          sortable: false,
          property: 'download_link',
          header: (
            <Text weight="bold" wordBreak="break-all" size="14pt">
              Download
            </Text>
          ),
          align: 'end'
        }
      ]}
      data={paginatedDocs}
      primaryKey="id"
    />
  );
  return (
    <Box margin={{ horizontal: '30px', vertical: '20px' }}>
      <Box fill="horizontal">{table}</Box>
      <Box align="end">{pageSelector}</Box>
    </Box>
  );
};
